window.printSelectedSections = function (selector = '.printable') {
  const blocks = document.querySelectorAll(selector);
  if (!blocks.length) {
    console.log('No printable content found.');
    return;
  }

  let printableHTML = '';
  blocks.forEach((block) => {
    printableHTML += block.outerHTML;
  });

  const titleEl = document.querySelector('.article-template__title');
  const title = titleEl ? titleEl.innerText : 'Print Preview';

  const payload = {
    title,
    content: printableHTML,
  };

  // iOS native print bridge
  if (window.webkit?.messageHandlers?.printContent) {
    window.webkit.messageHandlers.printContent.postMessage(payload);
    return;
  }

  // Fallback for browsers that support window.print()
  const supportsWindowPrint = typeof window.print === 'function';

  if (supportsWindowPrint && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
    // iOS Safari/Web fallback: inject directly into DOM
    const printContainer = document.createElement('div');
    printContainer.innerHTML = `
      <style>
        body { padding: 2rem; line-height: 1.3rem; }
        h1, h2, h3 { margin-top: 1.5rem; font-weight: 500; line-height: normal; }
        ul, ol { margin-left: 1.5rem; }
        li { margin-bottom: 0.5rem; }
        .magnolia-header { font-size: 2rem; width: 100%; text-align: center; margin-bottom: 3rem; }
      </style>
      <div class="magnolia-header">Magnolia</div>
      ${printableHTML}
    `;
    printContainer.id = 'temp-print-container';
    document.body.appendChild(printContainer);
    window.print();
    document.body.removeChild(printContainer);
    return;
  }

  // Android-friendly fallback: iframe
  try {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '100%';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>${title} - Magnolia</title>
          <style>
            body { padding: 2rem; line-height: 1.3rem; }
            h1, h2, h3 { margin-top: 1.5rem; font-weight: 500; line-height: normal; }
            ul, ol { margin-left: 1.5rem; }
            li { margin-bottom: 0.5rem; }
            .magnolia-header { font-size: 2rem; width: 100%; text-align: center; margin-bottom: 3rem; }
          </style>
        </head>
        <body>
          <div class="magnolia-header">Magnolia</div>
          ${printableHTML}
        </body>
      </html>
    `);
    doc.close();

    iframe.onload = function () {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      } catch (err) {
        console.error('Print error (iframe fallback):', err);
        alert('There was a problem printing the page. Please try again.');
      } finally {
        // Clean up
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      }
    };
  } catch (err) {
    console.error('General print error:', err);
    alert('There was a problem printing the page. Please try again.');
  }
};
